import { render } from "./BookingHelpDetails.vue?vue&type=template&id=0c7f3d6a&scoped=true"
import script from "./BookingHelpDetails.vue?vue&type=script&lang=js"
export * from "./BookingHelpDetails.vue?vue&type=script&lang=js"

import "./BookingHelpDetails.vue?vue&type=style&index=0&id=0c7f3d6a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7f3d6a"]])

export default __exports__